export const STATS = {
    // Home page
    all: {
        anchors: 184,
        borrowers: 19017,
        invoices: 435741,
        disbursed: 47577551909.53,
        aum: 4083412164.0,
    },
    // SaralPay Later
    bnpl: {
        anchors: 28,
        borrowers: 2006,
        invoices: 15273,
        disbursed: 12666552476.55,
        aum: 397491307.0,
    },
    // Vendor Finance
    vendor: {
        anchors: 13,
        borrowers: 89,
        invoices: 556,
        disbursed: 13021988232.1,
        aum: 1267879090.0,
    },
    // Supplychain finance
    scf: {
        anchors: 35,
        borrowers: 35,
        invoices: 1502,
        disbursed: 21889011200.88,
        aum: 2418041767.0,
    },
};
